import { create } from 'zustand';
import { getMe } from '../lib/api';
import type { Me } from '../types';

interface UserState {
  me: Me | null;
  loading: boolean;
  error: string | null;
  loaded: boolean;
  load: () => Promise<void>;
}

export const useUserStore = create<UserState>((set, get) => ({
  me: null,
  loading: false,
  error: null,
  loaded: false,
  load: async () => {
    if (get().loaded || get().loading) return;
    set({ loading: true, error: null });
    try {
      const me = await getMe();
      set({ me, loading: false, loaded: true });
    } catch (err) {
      set({ loading: false, error: err instanceof Error ? err.message : 'failed to load profile' });
    }
  },
}));
